import {
    goToStepThird,
    goToStepTwo,
    resetSatellite,
    setAddNewPayload,
    setBusSlider, setCloneTemplate,
    setEdgeNotPreview,
    setEdgeSelected,
    setEditEdgeData,
    setEditPayloadData,
    setEditTemplateData,
    setIsCloneTemplateFalse,
    setIsEdgeEdit,
    setIsNewPayloadCatalog,
    setIsNewTemplateFalse, setIsPayloadEdit, setIsTemplateEdit, setMissionEdit,
    setPayloadIndex,
    setPayloadSliderFalse,
    setPayloadsStepsToFalse, setSatDetails, setSatelliteClone, setSatelliteEdit, setShowTemplateDataFalse,
    setShowTemplateSlideToFalse,
    setTemplate,
    setUpdateReviewDataFalse,
} from '../store/MissionSlice';
import {
    clearBusUsage, setBusPercentage, setBusUsage, setEdgePowerUsage, setEdgeSizeUsage, setEdgeWeightUsage, setMaxUsage,
    setPayloadPowerUsage, setPayloadSizeUsage, setPayloadUsagePercentage, setPayloadWeightUsage, setEdgeUsagePercentage, setTotalAopCalculateUsage, setTotalPayloadAOPUsage, setTotalEdgeAOPUsage
} from '../store/UsageSlice';
import CommandCenterService from '../service/CommandCenterService';
import { toast } from 'react-toastify';
import { COLORS, VALIDATION_RULES } from './constants';
import * as Cesium from 'cesium';
import { getEnvVar } from '../envUtils';
import { isNil } from 'lodash';
import JSZip from 'jszip';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';

export const truncateNumber = (number, decimalPlaces) => {
    const integerPart = (number || 0).toString().split('.')[0];
    const fractionalPart = number.toString().split('.')[1];
    if (fractionalPart && fractionalPart.length > decimalPlaces) {
        const truncatedFraction = fractionalPart.substring(0, decimalPlaces);
        // Extra check: if only 1 decimal place and it's "0", return integer
        if (decimalPlaces === 1 && truncatedFraction === '0') {
            return Number(integerPart);
        }
        return Number(integerPart + '.' + truncatedFraction);
    } else if (!fractionalPart && decimalPlaces) {
        return Number(integerPart);
    } else {
        return number;
    }
};



export const truncateName = (name, limit = 20, startLength = 10, endLength = 10) => {
    if (typeof name !== 'string') return '';
    if (name.length > limit) {
        return `${name.substring(0, startLength)}...${name.substring(name.length - endLength)}`;
    }
    return name;
};

// Replace underscores with space
export const replaceUnderscoresWithSpaces = (value) => {
    return String(value ?? '').replace(/_/g, ' ');
};

// Format number with zero padding (e.g., 1 -> "01", 10 -> "10")
export const formatNumberWithZeroPadding = (number, minLength = 2) => {
    return String(number ?? 0).padStart(minLength, '0');
};

export const truncateAltitude = (number) => {
    if (Number.isInteger(number)) {
        return number;
    } else {
        const altValue = truncateNumber(number, 2)
        const parsedNumber = parseFloat(number.toFixed(2)); // Ensure the number is rounded to 2 decimal places
        // Check if the number is a whole number after rounding
        if (parsedNumber % 1 === 0) {
            return parsedNumber.toFixed(0); // Remove the decimal part(.00)
        }
        return altValue;
    }
};

// Example usage
// input #000000 output: [ 0, 0, 0, 1]
// input #7f11e0 output: [ 127, 17, 224, 1]

export const hexToRgbaArray = (hex, alpha = 255) => {
    // Remove the hash symbol if present
    hex = hex.replace('#', '');

    // Parse the hex color components
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Return the RGBA array
    return [r, g, b, alpha];
}

// convert epoch value to 02.16.2025 at 14:33:42 format

export const formatEpochToDateTime = (epoch, type = "UTC", devider = 'T') => {
    if (type === 'UTC') {
        const date = new Date(epoch * 1000);
        const year = date.getUTCFullYear();
        const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
        const day = date.getUTCDate().toString().padStart(2, '0');

        const hours = date.getUTCHours().toString().padStart(2, '0');
        const minutes = date.getUTCMinutes().toString().padStart(2, '0');
        const seconds = date.getUTCSeconds().toString().padStart(2, '0');
        const milisec = date.getUTCMilliseconds().toString().padStart(3, '0');
        return `${day}.${month}.${year} ${devider} ${hours}:${minutes}:${seconds}:${milisec}`;
    } else {
        const date = new Date(epoch * 1000);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        const milisec = date.getMilliseconds().toString().padStart(3, '0');
        return `${day}.${month}.${year} ${devider} ${hours}:${minutes}:${seconds}:${milisec}`;
    }
};

export const getFormatedDuration = (total_seconds) => {
    const hours = Math.floor(total_seconds / 3600);
    const minutes = Math.floor((total_seconds % 3600) / 60);
    const seconds = Math.floor(total_seconds % 60);
    const milliseconds = Math.round((total_seconds % 1) * 1000);
    return {
        hours,
        minutes,
        seconds,
        milliseconds
    }
}

export function formatDuration(total_seconds) {
    const { hours, minutes, seconds, milliseconds } = getFormatedDuration(total_seconds)
    const hourPart = hours > 0 ? `${hours}h` : '';
    const minutePart = minutes > 0 ? `${minutes}m` : '';
    const secondPart = seconds > 0 ? `${seconds}s` : '';
    const mili_secondPart = milliseconds > 0 ? `${truncateNumber(milliseconds, 3)}ms` : '';
    const parts = [hourPart, minutePart, secondPart, mili_secondPart].filter(Boolean);
    return parts.length > 0 ? parts.join(' ') : '0s';
}

/**
 * Converts seconds into a readable "Xmin Ys" format.
 *
 * Examples:
 *   formatSecondsDuration(75)         → "1min 15s"
 *   formatSecondsDuration(60)         → "1min"
 *   formatSecondsDuration(15)         → "15s"
 */
export const formatSecondsDuration = (value, options = {}) => {
    if (value === null || value === undefined) return null;
    const numeric = typeof value === 'number' ? value : Number(value);
    if (!Number.isFinite(numeric)) return null;

    const totalSeconds = Math.round(numeric);
    if (totalSeconds <= 0) {
        return options?.hideZero ? null : '0s';
    }

    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    const minutePart = minutes > 0 ? `${minutes}min` : '';
    const secondPart = seconds > 0 ? `${seconds}s` : '';

    if (!minutePart && !secondPart) {
        return options?.hideZero ? null : '0s';
    }

    return [minutePart, secondPart].join(' ').trim();
};

// convert epoch into minuits

export const epochToMinuite = (epochTime) => {
    // const date = new Date(epochTime);
    // return date.getHours() * 60 + date.getMinutes();
    return parseFloat((epochTime / 60).toFixed(2))
}

// file size format
// input: 1024 output: 1 KB
// input: 3145728 output: 3 MB
// input: 7864320 output: 7.5 MB
// input: 4294967296 output: 4 GB
export const formatFileSize = (bytes) => {
    if (bytes < 1000) return `${bytes} Bytes`;

    const kb = bytes / 1000;
    if (kb < 1000) return `${kb.toFixed(2)} KB`;

    const mb = kb / 1000;
    if (mb < 1000) return `${mb.toFixed(2)} MB`;

    const gb = mb / 1000;
    return `${gb.toFixed(2)} GB`;
};

export const eraseMissionData = (dispatch) => {
    setTotalAopCalculateUsage(0)
    dispatch(setPayloadIndex(1))
    dispatch(setMissionEdit(false))
    dispatch(setAddNewPayload(false))
    dispatch(setIsTemplateEdit(false));
    dispatch(setEditTemplateData({}));
    dispatch(setEditEdgeData({}));
    dispatch(setIsEdgeEdit(false));
    dispatch(setIsPayloadEdit(false));
    dispatch(setEditPayloadData({}));
    dispatch(resetSatellite());
    dispatch(setEdgeSelected(false));
    dispatch(setPayloadSizeUsage(0));
    dispatch(setPayloadWeightUsage(0));
    dispatch(setPayloadPowerUsage(0));
    dispatch(setEdgeSizeUsage(0));
    dispatch(setEdgeWeightUsage(0));
    dispatch(setEdgePowerUsage(0));
    dispatch(setIsNewPayloadCatalog(false));
    dispatch(setSatelliteEdit(false));
    dispatch(setSatelliteClone(false));
    dispatch(setUpdateReviewDataFalse());
    dispatch(setPayloadsStepsToFalse());
    dispatch(setShowTemplateSlideToFalse());
    dispatch(goToStepTwo({ goToPayloadStepOne: false, data: null, goTopreviewStep: false }));
    dispatch(goToStepThird({ goToEdge: false, data: null, goToEdgeSlider: false, goToEdgePreview: false }));
    dispatch(setEdgeNotPreview());
    dispatch(setPayloadSliderFalse());
    dispatch(setTemplate({}));
    dispatch(setShowTemplateDataFalse())
    dispatch(setIsNewTemplateFalse())
    dispatch(setIsCloneTemplateFalse())
    dispatch(clearBusUsage());
    dispatch(setCloneTemplate({}))
    dispatch(setBusSlider({
        busSliderSet: false,
        data: {},
        type: '',
        subSystem: '',
    }))
    dispatch(
        setPayloadUsagePercentage({
            size: 0,
            weight: 0,
            power: 0,
        })
    );
    dispatch(
        setEdgeUsagePercentage({
            size: 0,
            weight: 0,
            power: 0,
        })
    );
    dispatch(
        setBusPercentage({
            size: 0,
            weight: 0,
            power: 0,
        })
    );
    dispatch(
        setBusUsage({
            busSizeUsage: 0,
            busWeightUsage: 0,
            busPowerUsage: 0,
        })
    );

    dispatch(
        setMaxUsage({
            maxSizeUsage: 0,
            maxWeightUsage: 0,
            maxPowerUsage: 0,
        })
    );
    dispatch(
        setSatDetails({
            Configaration: {},
            Payloads: [],
            Edges: [],
            Template: {},
            TrueTwins: [],
            Sat_Id: "",
            Sat_name: "",
            Sat_desc: "",
        })
    );
}

//calculate the usage percentage (swap info)
export const calculateUsagePercentage = (allparams) => {
    let { temp, templateDataAvailable, dispatch, powerUsage, edgePowerUsage, edgeSizeUsage, edgeWeightUsage, sizeUsage, weightUsage } = allparams
    if (templateDataAvailable) {
        let payload_sizeCent = 0;
        let payload_weightCent = 0;
        let payload_powerCent = 0;

        let edge_sizeCent = 0;
        let edge_weightCent = 0;
        let edge_powerCent = 0;

        let bus_sizeCent = 0;
        let bus_weightCent = 0;
        let bus_powerCent = 0;

        let busSize = temp?.["template-attribute"]?.["bus-size"];
        let busWeight = temp?.["template-attribute"]?.["bus-mass"];
        let busPower = temp?.["template-attribute"]?.["bus-power"];
        let maxSize = temp?.["template-attribute"]?.["sizeInUnits"];
        let maxWeight = temp?.["template-attribute"]?.["maxWeightInKg"];
        let maxPower = temp?.["template-attribute"]?.["battery-capacity"];

        dispatch(
            setBusUsage({
                busSizeUsage: busSize,
                busWeightUsage: busWeight,
                busPowerUsage: busPower,
            })
        );

        dispatch(
            setMaxUsage({
                maxSizeUsage: maxSize,
                maxWeightUsage: maxWeight,
                maxPowerUsage: maxPower,
            })
        );

        payload_sizeCent = (sizeUsage * 100) / (maxSize);
        payload_sizeCent = parseFloat(truncateNumber(payload_sizeCent, 0));
        payload_weightCent = (weightUsage * 100) / (maxWeight);
        payload_weightCent = parseFloat(truncateNumber(payload_weightCent, 0));
        payload_powerCent = ((powerUsage) * 100) / (maxPower);
        payload_powerCent = parseFloat(truncateNumber(payload_powerCent, 0));
        dispatch(
            setPayloadUsagePercentage({
                size: payload_sizeCent,
                weight: payload_weightCent,
                power: payload_powerCent,
            })
        );

        edge_sizeCent = (edgeSizeUsage * 100) / (maxSize);
        edge_sizeCent = parseFloat(truncateNumber(edge_sizeCent, 0));
        edge_weightCent = (edgeWeightUsage * 100) / (maxWeight);
        edge_weightCent = parseFloat(truncateNumber(edge_weightCent, 0));
        edge_powerCent = ((edgePowerUsage) * 100) / (maxPower);
        edge_powerCent = parseFloat(truncateNumber(edge_powerCent, 0));
        dispatch(
            setEdgeUsagePercentage({
                size: edge_sizeCent,
                weight: edge_weightCent,
                power: edge_powerCent,
            })
        );

        bus_sizeCent = (busSize * 100) / temp?.["template-attribute"]?.["sizeInUnits"];
        bus_sizeCent = parseFloat(truncateNumber(bus_sizeCent, 0));
        bus_weightCent =
            (busWeight * 100) / temp?.["template-attribute"]?.["maxWeightInKg"];
        bus_weightCent = parseFloat(truncateNumber(bus_weightCent, 0));
        bus_powerCent =
            (busPower * 100) / temp?.["template-attribute"]?.["battery-capacity"];
        bus_powerCent = parseFloat(truncateNumber(bus_powerCent, 0));
        dispatch(
            setBusPercentage({
                size: bus_sizeCent,
                weight: bus_weightCent,
                power: bus_powerCent,
            })
        );
    }
};
//calculate total power usage (swap info)
export const calculate_Total_AOP_Usage = (payloads, edges, dispatch) => {
    let total_aop = 0;
    let total_payload_aop = 0;
    let total_edge_aop = 0;
    payloads?.map((v) => {
        if (v?.["user_data"]) {
            total_payload_aop = total_payload_aop + (Number(v["user_data"]?.['aop']) ? Number(v["user_data"]?.['aop']) : 0);
            return total_payload_aop;
        } else {
            total_payload_aop += Number(v["userData"]?.['aop'] ?? 0);
            return total_payload_aop;
        }
    })
    edges?.map((v) => {
        if (v?.['edge-device']?.["user_data"]) {
            total_edge_aop = total_edge_aop + (Number(v?.['edge-device']?.["user_data"]?.['total_aop']) ? Number(v?.['edge-device']?.["user_data"]?.['total_aop']) : 0);
            return total_edge_aop;
        } else if (v?.['edge-device']?.["user-data"]) {
            total_edge_aop = total_edge_aop + (Number(v?.['edge-device']?.["user-data"]?.['total_aop']) ? Number(v?.['edge-device']?.["user-data"]?.['total_aop']) : 0);
            return total_edge_aop;
        } else {
            total_edge_aop = total_edge_aop + (Number(v?.['edge-device']?.["userData"]?.['total_aop']) ? Number(v?.['edge-device']?.["userData"]?.['total_aop']) : 0);
            return total_edge_aop;
        }
    })
    total_aop = total_payload_aop + total_edge_aop
    dispatch(setTotalPayloadAOPUsage(truncateNumber(total_payload_aop, 2)));
    dispatch(setTotalEdgeAOPUsage(truncateNumber(total_edge_aop, 2)));
    dispatch(setTotalAopCalculateUsage(truncateNumber(total_aop, 2)));

    return {
        total_payload_aop,
        total_edge_aop,
        total_aop
    }
}
//calculate swap info of payload
export const calculatePayloadUsage = (allPayloads, dispatch) => {
    let size = 0;
    let power = 0;
    let weight = 0;
    allPayloads?.forEach((v) => {
        if (v?.["user-data"]) {
            size = size + Number(v["atmos-data"]?.["product-cookie"]?.["Size"]);
            power = power + Number(v["user-data"]?.["peak_solar_power"]);
            weight = weight + Number(v["atmos-data"]?.["weight_in_gms"]);
        } else if (v?.["user_data"]) {
            size = size + Number(v["atmos-data"]?.["product-cookie"]?.["Size"]);
            power = power + Number(v?.["user_data"]?.["peak_solar_power"]);
            weight = weight + Number(v["atmos-data"]?.["weight_in_gms"]);
        } else {
            size = size + Number(v["atmosData"]?.["product-cookie"]?.["Size"]);
            power = power + Number(v["userData"]?.["peak_solar_power"]);
            weight = weight + Number(v["atmosData"]?.["weight_in_gms"]);
        }
    });
    weight = weight / 1000;
    dispatch(setPayloadSizeUsage(size));
    dispatch(setPayloadPowerUsage(power));
    dispatch(setPayloadWeightUsage(weight));
    dispatch(setEdgePowerUsage(0));
    dispatch(setEdgeSizeUsage(0));
    dispatch(setEdgeWeightUsage(0));

    return {
        size,
        power,
        weight
    }
};
//calculate swap info of edge
export const calculateEdgeUsage = (edges, dispatch) => {
    let edgePower = 0
    let edgeSize = 0
    let edgeWeight = 0
    edges?.forEach(item => {

        if (item?.['edge-device']?.["user_data"]) {
            edgePower += Number(item?.['edge-device']?.['user_data']?.['peak_solar_power'] ?? 0)
            edgeSize += Number(item?.['edge-device']?.['atmos-data']?.["product-cookie"]?.["Size"] ?? 0)
            edgeWeight += Number(item?.['edge-device']?.['atmos-data']?.['weight_in_gms'] ?? 0) + (Number(item?.['edge-ssd']?.['atmos-data']?.['weight_in_gms'] ?? 0) * Number(item?.['edge-ssd']?.['user_data']?.["numUnits"]) ?? 0)
        } else if (item?.['edge-device']?.["userData"]) {
            edgePower += Number(item?.['edge-device']?.['userData']?.['peak_solar_power'] ?? 0)
            // edgeSize = edgeSize + Number(item?.['edge-device']?.['atmos-data']?.["product-cookie"]?.["Size"]) + (Number(item?.['edge-ssd']?.['atmos-data']?.["product-cookie"]?.["Size"]) * Number(item?.['edge-ssd']?.['user_data']?.["numUnits"]))
            edgeSize += Number(item?.['edge-device']?.['atmosData']?.["product-cookie"]?.["Size"] ?? 0)
            edgeWeight += Number(item?.['edge-device']?.['atmosData']?.['weight_in_gms'] ?? 0) + (Number(item?.['edge-ssd']?.['atmosData']?.['weight_in_gms'] ?? 0) * Number(item?.['edge-ssd']?.['userData']?.["numUnits"]) ?? 0)
        } else {
            edgePower += Number(item?.['edge-device']?.['user-data']?.['peak_solar_power'] ?? 0)
            edgeSize += Number(item?.['edge-device']?.['atmos-data']?.["product-cookie"]?.["Size"] ?? 0)
            edgeWeight += Number(item?.['edge-device']?.['atmos-data']?.['weight_in_gms'] ?? 0) + (Number(item?.['edge-ssd']?.['atmos-data']?.['weight_in_gms'] ?? 0) * Number(item?.['edge-ssd']?.['user-data']?.["numUnits"] ?? 0))
        }
    })
    edgeWeight = edgeWeight / 1000;

    dispatch(setEdgePowerUsage(Number(truncateNumber(edgePower, 2))));
    dispatch(setEdgeSizeUsage(Number(truncateNumber(edgeSize, 2))));
    dispatch(setEdgeWeightUsage(Number(truncateNumber(edgeWeight, 2))));

    return {
        edgePower,
        edgeSize,
        edgeWeight
    }
}

export const removeTruetwin = (trueTwinId, callFun) => {
    CommandCenterService.removeTrueTwin(trueTwinId)?.then((res) => {
        if (res) {
            callFun()
        }
    }).catch(err => {
        console.error(err)
    })
}

export const removeGStation = (item, trueTwinId, callFun) => {
    CommandCenterService.removeGroundStation(item?.['groundStationId'])?.then(res => {
        if (res) {
            removeTruetwin(trueTwinId, callFun)
        }
    }).catch(err => {
        console.error(err)
        removeTruetwin(trueTwinId, callFun)
    })
}

export const removeDeployTrueTwin = (item, callFun) => {
    let trueTwinId = item?.['trueTwinId']
    if (item?.['Category'] === 'TrueTwin') {
        CommandCenterService.disconnectGroundStation(item?.['groundStationId'], trueTwinId)?.then(res => {
            if (res.data.status === "Disconnected") {
                removeGStation(item, trueTwinId, callFun)
            } else {
                removeGStation(item, trueTwinId, callFun)
            }
        }).catch(err => {
            console.error(err)
            removeGStation(item, trueTwinId, callFun)
        })
    } else {
        removeTruetwin(trueTwinId, callFun)
    }

}


export const navigateTo = (path, navigate) => {
    navigate(`${process.env.PUBLIC_URL}/${path}`)
}

/**
 * Same as navigateTo but passes state to the destination (e.g. success message for toast).
 * Use when the target page needs to read location.state.
 */
export const navigateToWithState = (path, navigate, state) => {
    navigate(`${process.env.PUBLIC_URL}/${path}`, { state })
}

export function containsSpecialChars(str) {
    const specialChars = /[`!@#$%^&*+\=\[\]{};':"\\|,<>\/\?~]/;
    return specialChars.test(str);
}

export function isEmptyOrValidNumber(str) {
    const pattern = /^$|^\d{1,52}$/;
    return pattern.test(str);
}

export const preventSpecialChars = (e) => {
    if (containsSpecialChars(e.key) || e.keyCode === 13) {
        if (containsSpecialChars(e.key)) {
            showToastMessage('info', getSpecialCharacterMessageForName())
        }
        e.preventDefault();
    }
}

export const uuidv4 = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}


export const containsWhitespace = (str) => {
    if (str && !str.trim()) {
        return true
    } else {
        return false
    }

}

export const removeWhiteSpace = (value) => {
    return value.trimStart().replace(/\s{2,}/g, ' ')
}

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function getFileTypeFromFileName(fileName) {
    // Create a mapping of common file extensions to MIME types
    const fileExtensionToTypeMap = {
        txt: "text/plain",
        js: "application/javascript",
        json: "application/json",
        ts: "application/typescript",
        image: {
            jpg: "image/jpeg",
            jpeg: "image/jpeg",
            png: "image/png",
            gif: "image/gif",
            bmp: "image/bmp",
        },
        video: {
            mp4: "video/mp4",
            avi: "video/x-msvideo",
            mkv: "video/x-matroska",
        },
        pdf: "application/pdf",
        zip: "application/zip",
        log: "text/plain",
        bmp: "image/bmp",
    };

    // Extract the file extension from the given file name
    const fileExtension = fileName.split(".").pop().toLowerCase();

    // Look up the MIME type based on the file extension
    const fileType = fileExtensionToTypeMap[fileExtension];

    if (fileType) {
        if (typeof fileType === "object") {
            // If it's an object, look up the specific image or video type
            return fileType[fileExtension];
        } else {
            // Otherwise, return the found MIME type
            return fileType;
        }
    } else {
        // Return a default type if the extension is not recognized
        return "application/octet-stream"; // Generic binary data
    }
}

export function downloadFile(data, fileName) {
    var contentType = getFileTypeFromFileName(fileName);
    var binaryData = atob(data);
    var arrayBuffer = new ArrayBuffer(binaryData.length);
    var byteArray = new Uint8Array(arrayBuffer);
    for (var i = 0; i < binaryData.length; i++) {
        byteArray[i] = binaryData.charCodeAt(i);
    }
    var blob = new Blob([arrayBuffer], { type: contentType });

    // Create an object URL for the blob
    var url = URL.createObjectURL(blob);

    // Create an anchor element for the download
    var a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();

    URL.revokeObjectURL(url);
}

export const donloadJson = (data, name) => {
    const result = JSON.stringify(data)
    const blob = new Blob([result], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
}

export function validateIPv4(ip) {
    const ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}$/;
    return ipv4Regex.test(ip);
}

export const getYearLists = (length) => {
    const current = new Date().getFullYear();
    return Array.from({ length: length }, (_, i) => current + i);
}

export const getNextDays = (dateTimeString) => {
    const dates = new Set();
    for (let i = 0; i < 48; i++) {
        const nextDateTime = new Date(dateTimeString);
        nextDateTime.setTime(nextDateTime.getTime() + (i * 60 * 60 * 1000));
        const dateOnly = nextDateTime.getDate();
        dates.add(dateOnly);
    }
    return [...dates];
}

export const getRandomFourDigits = () => {
    return Math.floor(1000 + Math.random() * 9000);
}

export const onKeyDown = (e) => {
    if (['e', 'E', '+', '-'].includes(e.key) || e.keyCode === 13) {
        e.preventDefault();
    }
}

export const onKeyDownAllowNegative = (e) => {
    if (['e', 'E', '+'].includes(e.key) || e.keyCode === 13) {
        e.preventDefault();
    }
}

export const handleArrowKeyDown = (e, value, input, range, showToastMessage) => {

    const currentValue = parseFloat(value) || 0;
    const min = range?.MIN;
    const max = range?.MAX;
    const parameter = range?.PARAMETER;

    // Block non-numeric keys
    if (['e', 'E', '+', '-'].includes(e.key) || e.keyCode === 13) {
        e.preventDefault();
    }

    // Handle Arrow Up (Increment) at max
    if (e.key === "ArrowUp" && currentValue >= max) {
        showToastMessage('info', `${input} must be between ${min} & ${max}${parameter ? ` ${parameter}` : ''}`);
        e.preventDefault(); // Prevent default increment
    }

    // Handle Arrow Down (Decrement) at min
    if (e.key === "ArrowDown" && currentValue <= min) {
        showToastMessage('info', `${input} must be between ${min} & ${max}${parameter ? ` ${parameter}` : ''}`);
        e.preventDefault(); // Prevent default decrement
    }
}

export const preventEnterKey = (e) => {
    if (e.keyCode === 13) {
        e.preventDefault();
    }
}

export const preventKeyInputs = (e, keys) => {
    if (keys.includes(e.key) || e.keyCode === 13) {
        e.preventDefault();
        return false
    }
    return true
}

export const validateNumberWithoutDecimal = (e) => {
    if (['e', 'E', '+', '-', '.'].includes(e.key) || e.keyCode === 13) {
        e.preventDefault();
    }
}

export const getInvalidRangeErrorMessage = (name, min, max, parameters) => {
    return `${name} must be between ${min} and ${max} ${parameters ? parameters : ''}`
}

export const getInputLengthErrorMessage = (length) => {
    return `Maximum ${length} digits allowed`
}

/**
 * Validates whether a given string is a valid decimal number input
 * allowing up to a specified number of decimal places.
 *
 * ✅ Supports:
 * - Positive and negative numbers
 * - Optional decimal point
 * - Partial inputs during typing (e.g., "-", "-.", "")
 *
 * ❌ Disallows:
 * - More than the allowed number of decimal places
 * - Invalid characters (e.g., letters, multiple dots)

 * @param {string} value - The input value to validate.
 * @param {number} decimalPlaces - The maximum number of digits allowed after the decimal point.
 * @returns {boolean} True if the value is a valid decimal number (or partial valid input), false otherwise.
 */
export const checkDecimal = (value, decimalPlaces) => {
    if (value === '' || value === '-' || value === '-.') return true;
    const regex = new RegExp(`^-?\\d*\\.?\\d{0,${decimalPlaces}}$`);
    return regex.test(value);
};

/**
 * Clamps an input event's value to a maximum number of decimal places.
 * If clamped, updates e.target.value, shows a single toast, and returns true.
 * Otherwise returns false and does not modify the event value.
 *
 * @param {any} e - Change event from an input
 * @param {number} maxDecimals - Maximum allowed decimal places
 * @param {function} toastFn - Optional toast function (type, message)
 * @returns {boolean} - true if clamped (and caller should return early), false otherwise
 */
export const clampToDecimalsOnChange = (e, maxDecimals = 8, toastFn = showToastMessage) => {
    const raw = typeof e === 'string' ? e : e.target.value ?? '';
    const parts = String(raw).split('.');
    if (parts.length === 2 && parts[1].length > maxDecimals) {
        if (typeof toastFn === 'function') {
            toastFn('info', `Maximum ${maxDecimals} decimal places allowed`);
        }
        return true;
    }
    return false;
}

// /**
//  * Validates whether the provided email is in a proper format.
//  * 
//  * This function ensures:
//  * - Email starts with an alphanumeric character.
//  * - Domain name (after @) starts with a letter.
//  * - TLD (e.g., .com) has at least two alphabetic characters.
//  * - Standard characters like dot (.), underscore (_), percent (%), plus (+), and dash (-) are allowed in the local part.
//  * 
//  * ❌ Invalid email examples handled:
//  * - _____@gmail.com         → Starts with special characters
//  * - …………@gmail.com          → Starts with invalid characters
//  * - _akash@gmail.com        → Starts with underscore
//  * - .ak@gmail.com           → Starts with dot
//  * - akash@1234.com          → Domain starts with a number
//  * - akashkmr                → Missing domain part
//  * - akashkmr@123            → Domain missing TLD
//  * - user@.com               → Domain starts with dot
//  * - user-@gmail.com         → Domain ends with dash
//  * 
//  * ✅ Valid examples:
//  * - akash.kmr@gmail.com
//  * - user_name123@test.co
//  * 
//  * @param {string} email - The email address to validate.
//  * @returns {boolean} - Returns true if the email is valid, false otherwise.
//  */
// export function isEmailValid(email) {
//     const emailPattern = /^[a-zA-Z0-9](?:[a-zA-Z0-9._%+-]*[a-zA-Z0-9])?@[a-zA-Z][a-zA-Z0-9.-]*\.[a-zA-Z]{2,}$/;
//     return emailPattern.test(email);
// }

/**
 * Checks whether the input string is a valid basic email-like format.
 * A valid format must contain exactly one "@" symbol,
 * with at least one character before and after it.
 *
 * @param {string} input - The string to validate.
 * @returns {boolean} True if the input has a basic valid email format, false otherwise.
 */
export function isEmailValid(input) {
    const parts = input.split('@');

    // Check if exactly one '@' and both sides are non-empty
    return parts.length === 2 && parts[0].length > 0 && parts[1].length > 0;
}

export const validateInputRange = (name, value, min, max, length, paramaters) => {
    const decimalPart = value.toString().split('.')[1];
    const decimalPartLength = decimalPart ? decimalPart.length : 0;
    const maxDecimalLength = 8;
    const valueLength = value.toString()?.includes('.') ? value.toString().split('.')[0].length - decimalPartLength : value.toString().length;
    if (value === '' || (decimalPartLength <= maxDecimalLength && Number(value) >= 0 && Number(value) <= max && valueLength <= length)) {
        return { success: true, value: value !== '' ? Number(value) : '' }
    } else return {
        error: (Number(value) < min || Number(value) > max) ? getInvalidRangeErrorMessage(name, min, max, paramaters) : (decimalPartLength > maxDecimalLength) ? `Maximum ${maxDecimalLength} decimal places allowed` : valueLength > length ? getInputLengthErrorMessage(length) : getInvalidRangeErrorMessage(name, min, max, paramaters)
    }
}

export const validateLatLongInputRange = (name, value, min, max, length, paramaters) => {
    const decimalPart = value.toString().split('.')[1];
    const decimalPartLength = decimalPart ? decimalPart.length : 0;
    const maxDecimalLength = 5;
    const valueLength = value?.includes('.') ? value.toString().split('.')[0].length - decimalPartLength : value.toString().length;
    if (value === '' || (decimalPartLength <= maxDecimalLength && Number(value) >= min && Number(value) <= max && valueLength <= length)) {
        return { success: true, value: value !== '' ? Number(value) : '' }
    } else return {
        error: (Number(value) < min || Number(value) > max) ? getInvalidRangeErrorMessage(name, min, max, paramaters) : (decimalPartLength > maxDecimalLength) ? `Maximum ${maxDecimalLength} decimal places allowed` : valueLength > length ? getInputLengthErrorMessage(length) : getInvalidRangeErrorMessage(name, min, max, paramaters)
    }
}

// Singleton toast — only one toast visible at a time; updates in-place if already active
export const TOAST_ID = 'app-toast';
const TOAST_AUTO_CLOSE = 3000;

const buildToastOptions = (type) => ({
    toastId: TOAST_ID,
    className: `custom-toast-${type}`,
    icon: true,
    autoClose: TOAST_AUTO_CLOSE,
});

export const showToastMessage = (type, message) => {
    const options = buildToastOptions(type);

    if (toast.isActive(TOAST_ID)) {
        toast.update(TOAST_ID, { ...options, render: message, type });
    } else if (toast[type]) {
        toast[type](message, options);
    } else {
        toast(message, { ...options, type });
    }
};

// Loading toast — persistent toast with spinner that doesn't auto-close
const LOADING_TOAST_ID = 'app-loading-toast';

export const loadingToast = ({ loading, message }) => {
    if (loading) {
        // Show loading toast with no auto-close — uses same styling as showToastMessage
        const options = {
            toastId: LOADING_TOAST_ID,
            className: 'custom-toast-loading',
            icon: true,
            autoClose: false,
            closeButton: false,
        };

        if (toast.isActive(LOADING_TOAST_ID)) {
            // Update existing loading toast
            toast.update(LOADING_TOAST_ID, {
                ...options,
                render: message,
                type: 'loading',
            });
        } else {
            // Create new loading toast
            toast.loading(message, options);
        }
    } else {
        // Dismiss loading toast
        if (toast.isActive(LOADING_TOAST_ID)) {
            toast.dismiss(LOADING_TOAST_ID);
        }
    }
};

export const validateWhiteSpacesAndSpecialChar = (rawInput) => {
    const sanitized = rawInput
        .replace(/^\s+/, "")
        .replace(/[^A-Za-z0-9\s()_\-.]/g, "")
    return sanitized
}

export const getCharacterLimitMessage = (limit) => {
    return `Maximum allowed limit of ${limit} characters`;
}

export const getSpecialCharacterMessage = () => {
    return 'Cannot use special character';
}

// common speacial character input validation for name input fields
export const getSpecialCharacterMessageForName = () => {
    return 'Name should not contain special characters';
}

export const getDeletionSuccessMessage = (item) => {
    return `${item} Deleted`;
}

export const getActionFailedMessage = () => {
    return 'Action Failed';
}

export const getSatelliteColor = (index) => {
    return COLORS[index % COLORS.length];
};

export const checkCommonNameValidation = (name, length) => {
    if (name.startsWith(".")) {
        return false;
    }
    else if (containsSpecialChars(name)) {
        const message = getSpecialCharacterMessageForName()
        showToastMessage('info', message)
        return false
    } else if (name.length > length) {
        const message = getCharacterLimitMessage(length)
        showToastMessage('info', message)
        return false
    } else return true
}

/**
 * Common configurable input field validation for name, description, version etc.
 * @param {string} value - The input value to validate
 * @param {object} options - Configuration options
 * @param {string} options.fieldName - Label used in toast messages (e.g. 'Name', 'Version')
 * @param {number} options.maxLength - Maximum allowed character length
 * @param {boolean} [options.checkSpecialChars=false] - Whether to validate against special characters
 * @param {RegExp} [options.allowedCharsRegex] - Custom regex for allowed characters (defaults to alphanumeric + ( ) - _ . space)
 * @returns {boolean} - true if valid, false if invalid
 */
export const validateInputField = (value, { fieldName, maxLength, checkSpecialChars = false, allowedCharsRegex = /^[a-zA-Z0-9()\-_. ]*$/ } = {}) => {
    if (value.length > maxLength) {
        showToastMessage('info', `${fieldName} must be ${maxLength} characters or less.`)
        return false
    }
    if (checkSpecialChars && value && !allowedCharsRegex.test(value)) {
        showToastMessage('info', `${fieldName} contains invalid characters. Only letters, numbers, and ( ) - _ . are allowed.`)
        return false
    }
    return true
}

// Function to format a timestamp into a human-readable date and time in UTC
export const formatTime = (timestamp) => {
    const date = new Date(timestamp * 1000);
    const options = {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'UTC'
    };

    const [month, day, year] = date.toLocaleDateString('en-US', options).split(/,\s+| /);
    const [time] = date.toLocaleTimeString('en-US', { timeZone: 'UTC' }).split(' ');

    const ordinal = (n) => [, 'st', 'nd', 'rd'][n % 100 >> 3 ^ 1 && n % 10] || 'th';

    return `${day}${ordinal(day)} ${month}, ${year} ${time} UTC`;
};
export function getYears(start, end) {
    const years = [];
    for (let year = start; year <= end; year++) {
        years.push(year);
    }
    return years;
}

export const checkValidDecimal = (value) => {
    const decimalPart = value.toString().split('.')[1]; // Get the decimal part
    return decimalPart ? (decimalPart?.length > 4 ? false : true) : true;
}

export const getFormatedTime = (time) => {
    const date = new Date(time * 1000);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');

    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const seconds = date.getUTCSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day}T ${hours}:${minutes}:${seconds}Z`;
}

export const getColourArray = (colorString) => {
    const colorArray = colorString
        .replace("[", "")
        .replace("]", "")
        .split(",")
        .map(Number);
    return colorArray;
}

export const offline = () => {
    return (getEnvVar('REACT_APP_AIRGAP') || 'false').toLowerCase() === 'true';
};
export const collectEnable = () => {
    return (getEnvVar('REACT_APP_COLLECT') || 'true').toLowerCase() === 'true';
};

// Create offline Natural Earth imagery provider
export const createNaturalEarthProvider = () => {
    return new Cesium.TileMapServiceImageryProvider({
        url: Cesium.buildModuleUrl('Assets/Textures/NaturalEarthII'),
        credit: 'Natural Earth II',
        fileExtension: 'jpg',
        maximumLevel: 5, // Adjust based on your available tiles
        rectangle: Cesium.Rectangle.fromDegrees(-180, -90, 180, 90)
    });
};


/**
 * Converts a UNIX timestamp (in seconds) to a formatted UTC time string.
 * 
 * @param {number} time - The UNIX timestamp in seconds.
 * @returns {string} - Formatted string in the format: YYYY-MM-DDT HH:MM:SSZ (UTC).
 *
 * Example:
 *   Input: 1715600000
 *   Output: "2024-05-13T 10:13:20Z"
 */
export const get_formated_time = (time) => {
    const date = new Date(time * 1000);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');

    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const seconds = date.getUTCSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day}T ${hours}:${minutes}:${seconds}Z`;
}
// for Local time 
export const get_formated_local_time = (time) => {
    const date = new Date(time * 1000);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};


export const get_time_by_format_type = (time, type = 'UTC') => {
    return type === 'Local' ? get_formated_local_time(time) : get_formated_time(time)
}

// Sensor placement validation functions
export const validateAngleRange = (number, min, max) => {
    const value = parseFloat(number);
    if (number.trim() === "" || (!isNaN(value) && value >= min && value <= max)) {
        return { success: true, value: number === "" ? "" : value };
    }
    return { error: true }
};


export const validateMagnitude = (x, y, z) => {
    const parsedX = parseFloat(x);
    const parsedY = parseFloat(y);
    const parsedZ = parseFloat(z);
    const magnitude = Math.sqrt(parsedX ** 2 + parsedY ** 2 + parsedZ ** 2);
    // Allowing a small tolerance due to floating point precision
    const EPSILON = 1e-6;
    if (Math.abs(magnitude - 1) > EPSILON) {
        return `Vector magnitude must be 1. Current magnitude is ${magnitude.toFixed(6)}.`;
    } return {
        success: true,
    };
}


export const formatDecimal = (value, precision) => {
    const moiValue = Number(value);
    if (isNaN(moiValue)) return value;

    const [integer, decimal] = moiValue.toString().split('.');
    if (decimal && decimal.length > precision) {
        return parseFloat(moiValue.toFixed(precision));
    }
    return moiValue;
}

export const setLightingInCanvas = () => {
    return (
        <>
            {/* Ambient light for general base lighting */}
            <ambientLight intensity={5} />
            {/* 4 directional lights from all sides */}
            <directionalLight position={[20, 0, 0]} intensity={5} />
            <directionalLight position={[-20, 0, 0]} intensity={5} />
            <directionalLight position={[0, 0, 20]} intensity={5} />
            <directionalLight position={[0, 0, -20]} intensity={5} />
            {/* Overhead light for top lighting */}
            <directionalLight position={[0, 20, 0]} intensity={1} />
        </>
    )
}

export const convertDecimalMinutesToMMSS = (duration, useClone = false) => {
    if (!duration || duration <= 0) return '0s';

    const totalSeconds = Math.floor(duration * 60);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const pad = (val) => (val >= 10 ? `${val}` : `0${val || 0}`);

    let result = '';

    // Hours
    if (hours > 0) {
        result += useClone ? `${hours}:` : `${hours}h`;
    }

    // Minutes
    if (useClone) {
        result += `${pad(minutes)}:`;
    } else if (minutes > 0) {
        result += result ? ` ${minutes}m` : `${minutes}m`;
    }

    // Seconds
    if (useClone) {
        result += pad(seconds);
    } else if (seconds > 0) {
        result += result ? ` ${seconds}s` : `${seconds}s`;
    }

    return result || '0s';
};


export const hasDuplicatePoints = (points) => {
    if (!Array.isArray(points)) return false;

    const seen = new Set();
    for (let i = 0; i < points.length; i++) {
        const key = `${points[i].lat},${points[i].lng}`;
        if (seen.has(key)) return i;
        seen.add(key);
    }
    return false;
};


export const areAllPointsCollinear = (points) => {
    if (!Array.isArray(points) || points.length < 3) return false;

    const { lat: x0, lng: y0 } = points[0];
    const { lat: x1, lng: y1 } = points[1];

    for (let i = 2; i < points.length; i++) {
        const { lat: xi, lng: yi } = points[i];
        if ((x1 - x0) * (yi - y0) !== (y1 - y0) * (xi - x0)) {
            return false;
        }
    }
    return true;
};


export const isPolygonValid = (points) => {
    if (points.length < 3) return false;
    if (hasDuplicatePoints(points)) return false;
    if (areAllPointsCollinear(points)) return false;
    return true;
}



export const isIPValid = (value) => {
    if (!value) return false;
    const parts = value.split('.');
    if (parts.length !== 4) {
        return false;
    }
    return parts.every(part => {
        if (part.length === 0) return false;
        if (/[^0-9]/.test(part)) return false;
        const num = Number(part);
        return num >= 0 && num <= 255;
    });
}

export const truncateNameBasedOnCase = (name, upperCaseLength, normalLength) => {
    if (!name) return "NA";

    if (name === name.toUpperCase()) {
        return name.length > upperCaseLength
            ? name.substring(0, upperCaseLength) + "..."
            : name;
    }

    return name.length > normalLength
        ? name.substring(0, normalLength) + "..."
        : name;
}

export const getApiFailureMessage = (error, method) => {
    const updatedMethod = {
        'Create': 'creating',
        'Update': 'updating',
        'Delete': 'deleting',
        'Clone': 'cloning',
        'Fetch': 'fetching',
        'Generate': 'generating'
    }
    const baseMessage = method ? `Something went wrong while ${updatedMethod[method]}` : 'Something went wrong. Try again.'
    return typeof error?.response?.data === 'string' ? error?.response?.data : error?.response?.data?.message || baseMessage
}
export const getBandKey = (band, isFrequency) => {
    if (band === 'UHF') {
        return isFrequency ? band : 'U'
    } else if (['S-band', 'X-band'].includes(band)) {
        return band === 'S-band' ? 'S' : 'X'
    } else {
        return isFrequency ? 'KA' : 'K'
    }
}


/**
 * Merges multiple class names into a single string.
 * 
 * 🧩 Usage:
 * - Pass any number of class names (string, undefined, null, or false)
 * - Automatically filters out falsy values (like undefined, null, false)
 * - Joins valid class names with a space
 * 
 * Example:
 * ```ts
 * mergeClassNames("btn", isActive && "btn-active", disabled && "opacity-50")
 * // => "btn btn-active"
 * ```
 */
export function mergeClassNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

/**
 * Show a toast message when the input value is out of range.
 * 
 * @param {string} name - The name of the input field.
 * @param {number|string} value - The current value of the input field.
 * @param {number} min - The minimum allowed value.
 * @param {number} max - The maximum allowed value.
 * @param {string} [parameter] - An optional parameter to be included in the toast message.
 */
export const onBlur = (name, value, min, max, parameter) => {
    if (Number(value) < min || Number(value) > max) {
        showToastMessage('info', `${name} should be between ${min} and ${max}${parameter || ''}`)
    }
}

export const validateOrbitConfigForm = (formData) => {
    if (!formData.epoch) {
        showToastMessage('error', 'Epoch is required')
        return false
    } else if (formData.altitude === '' || VALIDATION_RULES.ORBITAL_ALTITUDE.MIN > Number(formData.altitude) || VALIDATION_RULES.ORBITAL_ALTITUDE.MAX < Number(formData.altitude)) {
        showToastMessage('error', formData.altitude === '' ? 'Altitude is required' : getInvalidRangeErrorMessage('Altitude', VALIDATION_RULES.ORBITAL_ALTITUDE.MIN, VALIDATION_RULES.ORBITAL_ALTITUDE.MAX, 'km'))
        return false
    } else if (formData.eccentricity === '' || VALIDATION_RULES.ORBITAL_ECCENTRICITY.MIN > Number(formData.eccentricity) || VALIDATION_RULES.ORBITAL_ECCENTRICITY.MAX < Number(formData.eccentricity)) {
        showToastMessage('error', formData.altitude === '' ? 'Eccentricity is required' : getInvalidRangeErrorMessage('Eccentricity', VALIDATION_RULES.ORBITAL_ECCENTRICITY.MIN, VALIDATION_RULES.ORBITAL_ECCENTRICITY.MAX))
        return false
    } else if (formData.inclination === '' || VALIDATION_RULES.ORBITAL_INCLINATION.MIN > Number(formData.inclination) || VALIDATION_RULES.ORBITAL_INCLINATION.MAX < Number(formData.inclination)) {
        showToastMessage('error', formData.inclination === '' ? 'Inclination is required' : getInvalidRangeErrorMessage('Inclination', VALIDATION_RULES.ORBITAL_INCLINATION.MIN, VALIDATION_RULES.ORBITAL_INCLINATION.MAX, '°'))
        return false
    } else if (formData.RAAN === '' || VALIDATION_RULES.ORBITAL_RAAN.MIN > Number(formData.RAAN) || VALIDATION_RULES.ORBITAL_RAAN.MAX < Number(formData.RAAN)) {
        showToastMessage('error', formData.RAAN === '' ? 'RAAN is required' : getInvalidRangeErrorMessage('RAAN', VALIDATION_RULES.ORBITAL_RAAN.MIN, VALIDATION_RULES.ORBITAL_RAAN.MAX, '°'))
        return false
    } else if (formData.AP === '' || VALIDATION_RULES.ORBITAL_AP.MIN > Number(formData.AP) || VALIDATION_RULES.ORBITAL_AP.MAX < Number(formData.AP)) {
        showToastMessage('error', formData.AP === '' ? 'Argument of Perigee is required' : getInvalidRangeErrorMessage('Argument of Perigee', VALIDATION_RULES.ORBITAL_AP.MIN, VALIDATION_RULES.ORBITAL_AP.MAX, '°'))
        return false
    } else if (formData.TA === '' || VALIDATION_RULES.ORBITAL_TA.MIN > Number(formData.TA) || VALIDATION_RULES.ORBITAL_TA.MAX < Number(formData.TA)) {
        showToastMessage('error', formData.TA === '' ? 'True Anomaly is required' : getInvalidRangeErrorMessage('True Anomaly', VALIDATION_RULES.ORBITAL_TA.MIN, VALIDATION_RULES.ORBITAL_TA.MAX, '°'))
        return false
    }
    return true
}

export const handleJsonFileUpload = () => {
    return new Promise((resolve) => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".json";
        input.onchange = (e) => {
            const file = e.target.files && e.target.files[0];
            if (!file || file.type !== "application/json") {
                resolve({
                    result: null,
                    status: "error",
                    message: "Invalid file format. Please upload a .json file."
                });
                return;
            }
            const reader = new FileReader();
            reader.onload = (ev) => {
                const content = ev.target.result;
                const formData = new FormData();
                formData.append("file", new Blob([content], { type: "application/json" }), file.name);
                formData.append("bandType", "Backdoor");
                resolve({
                    result: {
                        name: file.name,
                        data: formData
                    },
                    status: "success",
                    message: "File uploaded successfully"
                });
            };
            reader.readAsText(file);
        };
        input.click();
    });
};


/**
 * Returns the maximum bounds of the screen.
 * If the code is running in a server-side rendering (SSR) environment,
 * it will return { width: 0, height: 0 } to avoid errors.
 * @returns {Object} An object with width and height properties.
 */
export const getMaxBounds = () => {
    if (typeof window === 'undefined') {
        return { width: 0, height: 0 }; // SSR safe
    }

    return {
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight,
    };
};

// Processes numeric input values: normalizes empty/'.' to '0'/'0.', removes leading zeros, preserves decimals
export const processInputValue = (value) => {
    if (value === '') return '0'
    if (value === '.') return '0.'
    if (/^0\./.test(value)) return value // Preserve "0." and "0.xxx"
    if (/^0+$/.test(value)) return '0' // Multiple zeros -> single zero
    if (/^0+[1-9]/.test(value)) return value.replace(/^0+/, '') // Remove leading zeros
    return value
}

export const formatExecDurationValue = (value) => {
    if (isNil(value)) return null;
    const numeric = typeof value === 'number' ? value : Number(value);
    if (Number.isFinite(numeric)) {
        if (numeric === 0) return null;
        return `${numeric}min`;
    }
    return String(value);
}

export const base64ToHex = (str) => {
    try {
        if (!str || typeof str !== 'string') return '';
        const raw = atob(str);
        let result = "";
        for (let i = 0; i < raw.length; i++) {
            const hex = raw.charCodeAt(i).toString(16);
            result += hex.length === 2 ? hex : "0" + hex;
            result += " ";
        }
        return result.toUpperCase().trim();
    } catch (error) {
        console.error('base64ToHex failed:', str, error);
        return '';
    }
};

export const isInvalidMinMaxRange = (minVal, maxVal) => {
    const min = String(minVal ?? '').trim();
    const max = String(maxVal ?? '').trim();
    if (min === '' || max === '') return false;
    const minN = Number(min);
    const maxN = Number(max);
    return !isNaN(minN) && !isNaN(maxN) && minN > maxN;
}

// ── 3D model constants & loaders ───────────────────────────────────────────
/** Max allowed size for uploaded model files (100 MB) */
export const MAX_MODEL_FILE_SIZE_BYTES = 100 * 1024 * 1024;

/**
 * Creates a GLTFLoader with optional DRACO decoder (when not offline).
 * @param {THREE.LoadingManager} [manager] - Optional loading manager for URL resolution
 * @returns {GLTFLoader}
 */
export const createGltfLoader = (manager) => {
    const gltfLoader = manager ? new GLTFLoader(manager) : new GLTFLoader();
    if (!offline()) {
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.5.6/');
        gltfLoader.setDRACOLoader(dracoLoader);
    }
    return gltfLoader;
};

// Normalizes different loader/exception shapes into a readable single-line message.
const getModelLoadErrorMessage = (error, fallback = 'Error loading model') => {
    if (!error) return fallback;
    if (typeof error === 'string') return error;
    if (error?.message) return error.message;
    if (error?.target?.statusText) return error.target.statusText;
    if (error?.toString && error.toString() !== '[object Object]') return error.toString();
    return fallback;
};

// Handles model-load failures uniformly by normalizing message, showing toast, and resolving safely.
const notifyModelLoadFailure = ({ error, onError, resolve, fallback = 'Error loading model' }) => {
    const detail = getModelLoadErrorMessage(error, fallback);
    const message = `Error loading model: ${detail}`;
    showToastMessage('error', message);
    if (typeof onError === 'function') onError(message);
    resolve(null);
};

// Builds a consistent invalid-GLB result object using normalized parser/read error details.
const getGlbIntegrityFailure = (error, fallback = 'Failed to parse .glb file') => {
    const detail = getModelLoadErrorMessage(error, fallback);
    return { isValid: false, message: `Failed to parse .glb file: ${detail}` };
};

/**
 * Loads a single GLTF/GLB from URL and returns the scaled scene.
 * @param {string} url - URL (e.g. .glb or blob URL)
 * @param {{ targetSize?: number, onError?: (message: string) => void }} [options] - targetSize for scaleScene (default 2)
 * @returns {Promise<THREE.Object3D | null>}
 */
export const loadGltfFromUrl = (url, options = {}) => {
    const { targetSize = 2, onError } = options;
    return new Promise((resolve) => {
        try {
            const loader = createGltfLoader();
            loader.load(
                url,
                (gltf) => {
                    const scene = scaleScene(gltf.scene, targetSize);
                    resolve(scene);
                },
                undefined,
                (err) => {
                    notifyModelLoadFailure({ error: err, onError, resolve });
                }
            );
        } catch (e) {
            notifyModelLoadFailure({ error: e, onError, resolve });
        }
    });
};

/**
 * Loads GLTF/GLB from a main blob URL with a file map for relative refs (.bin, etc.).
 * @param {string} mainBlobUrl - Blob URL of the main .glb or .gltf
 * @param {Record<string, string>} fileMap - Map of filename -> blob URL
 * @param {{ targetSize?: number, onError?: (message: string) => void }} [options] - targetSize for scaleScene (default 2)
 * @returns {Promise<THREE.Object3D | null>}
 */
export const loadGltfModelWithMap = (mainBlobUrl, fileMap, options = {}) => {
    const { targetSize = 2, onError } = options;
    return new Promise((resolve) => {
        try {
            const manager = new THREE.LoadingManager();
            manager.setURLModifier((url) => {
                const fileName = url.split('/').pop();
                if (fileName && fileMap[fileName]) return fileMap[fileName];
                return url;
            });
            const loader = createGltfLoader(manager);
            loader.load(
                mainBlobUrl,
                (gltf) => {
                    const scene = scaleScene(gltf.scene, targetSize);
                    resolve(scene);
                },
                undefined,
                (err) => {
                    notifyModelLoadFailure({ error: err, onError, resolve });
                }
            );
        } catch (e) {
            notifyModelLoadFailure({ error: e, onError, resolve });
        }
    });
};

/**
 * Validates file size against max (default MAX_MODEL_FILE_SIZE_BYTES). Shows toast on failure.
 * @param {File} file
 * @param {number} [maxBytes]
 * @returns {boolean} true if valid
 */
export const validateModelFileSize = (file, maxBytes = MAX_MODEL_FILE_SIZE_BYTES) => {
    if (file.size > maxBytes) {
        showToastMessage('error', 'File size must be less than 100 MB');
        return false;
    }
    return true;
};

/**
 * Validates that a .glb file is parseable by GLTFLoader.
 * @param {File} file
 * @returns {Promise<{ isValid: boolean, message: string | null }>} validation result with root-cause message
 */
export const validateGlbFileIntegrity = async (file) => {
    if (!file || !file.name?.toLowerCase().endsWith('.glb')) {
        return { isValid: false, message: 'Expected a valid .glb file' };
    }

    try {
        const data = await file.arrayBuffer();
        return await new Promise((resolve) => {
            try {
                const loader = createGltfLoader();
                loader.parse(
                    data,
                    '',
                    (gltf) => {
                        if (gltf?.scene) {
                            resolve({ isValid: true, message: null });
                            return;
                        }
                        resolve({ isValid: false, message: 'GLB parsed but scene data is missing' });
                    },
                    (error) => {
                        resolve(getGlbIntegrityFailure(error));
                    }
                );
            } catch (error) {
                resolve(getGlbIntegrityFailure(error));
            }
        });
    } catch (error) {
        return getGlbIntegrityFailure(error, 'Unable to read .glb file data');
    }
};

/**
 * Packs an array of model Files into a zip Blob named after the main model file.
 * @param {File[]} files - e.g. [.gltf, .bin] or [.glb]
 * @returns {Promise<File>}
 */
export const packFilesIntoModelZip = async (files) => {
    const jszip = new JSZip();
    for (const f of files) {
        jszip.file(f.name, await f.arrayBuffer());
    }
    const blob = await jszip.generateAsync({ type: 'blob', compression: 'DEFLATE' });
    const mainFile = files.find(f => f.name.endsWith('.gltf') || f.name.endsWith('.glb'));
    const baseName = mainFile
        ? mainFile.name.replace(/\.(gltf|glb)$/i, '')
        : 'satellite_model';
    return new File([blob], `${baseName}.zip`, { type: 'application/zip' });
};

/**
 * Parameterized helper for Case 2 (single .zip) and Case 3 (.gltf + .bin manual selection).
 * Returns same shape so caller can set zipFile + extractedFiles uniformly.
 * @param {File[]} selectedFiles - One zip file (Case 2) or [.gltf, .bin?] (Case 3)
 * @param {'zip' | 'manual'} mode - 'zip' = extract from zip; 'manual' = validate and pack into zip
 * @returns {Promise<{ success: true, extractedFiles: File[], zipFile: File } | { success: false, message: string }>}
 */
export const processZipOrManualModelFiles = async (selectedFiles, mode) => {
    const allowedExts = ['.glb', '.gltf', '.bin', '.zip'];
    const checkExt = (f) => {
        const ext = f.name.substring(f.name.lastIndexOf('.')).toLowerCase();
        return allowedExts.includes(ext);
    };
    const checkSize = (f) => validateModelFileSize(f);

    if (mode === 'zip') {
        const zipFile = selectedFiles[0];
        if (!zipFile || !zipFile.name.toLowerCase().endsWith('.zip')) {
            return { success: false, message: 'Expected a single .zip file' };
        }
        if (!checkSize(zipFile)) return { success: false, message: 'File too large' };
        try {
            const extracted = await extract3DFilesFromZip(zipFile);
            const mainFile = extracted.find(f => f.name.endsWith('.glb') || f.name.endsWith('.gltf'));
            if (!mainFile) {
                showToastMessage('error', 'Zip must contain a .glb or .gltf file');
                return { success: false, message: 'Zip must contain a .glb or .gltf file' };
            }
            const gltfEntry = extracted.find(f => f.name.endsWith('.gltf'));
            if (gltfEntry) {
                const gltfJson = JSON.parse(await gltfEntry.text());
                const requiresBin = gltfJson?.buffers?.some((b) => b.uri?.endsWith('.bin'));
                if (requiresBin && !extracted.find(f => f.name.endsWith('.bin'))) {
                    showToastMessage('error', 'The .gltf inside the zip requires a .bin file which is missing.');
                    return { success: false, message: 'Missing .bin' };
                }
            }
            return { success: true, extractedFiles: extracted, zipFile };
        } catch (e) {
            showToastMessage('error', 'Failed to read zip file');
            return { success: false, message: 'Failed to read zip file' };
        }
    }

    // mode === 'manual'
    const gltfFile = selectedFiles.find(f => f.name.toLowerCase().endsWith('.gltf'));
    const binFile = selectedFiles.find(f => f.name.toLowerCase().endsWith('.bin'));
    if (!gltfFile) {
        showToastMessage('error', 'Please select a .gltf file (with its .bin if required)');
        return { success: false, message: 'Please select a .gltf file' };
    }
    for (const f of selectedFiles) {
        if (!checkExt(f)) {
            showToastMessage('error', 'Only .glb, .gltf, .bin, and .zip formats are supported');
            return { success: false, message: 'Invalid format' };
        }
        if (!checkSize(f)) return { success: false, message: 'File too large' };
    }
    try {
        const gltfJson = JSON.parse(await gltfFile.text());
        const requiresBin = gltfJson?.buffers?.some((b) => b.uri?.endsWith('.bin'));
        if (requiresBin && !binFile) {
            showToastMessage('error', 'This .gltf model requires a .bin file. Please select both files together.');
            return { success: false, message: 'Missing .bin' };
        }
    } catch {
        showToastMessage('error', 'Failed to parse .gltf file');
        return { success: false, message: 'Failed to parse .gltf' };
    }
    try {
        const packed = await packFilesIntoModelZip(selectedFiles);
        return { success: true, extractedFiles: selectedFiles, zipFile: packed };
    } catch (e) {
        showToastMessage('error', 'Failed to package model files into zip');
        return { success: false, message: 'Failed to package' };
    }
};

// Extract 3D model-related files (.glb, .gltf, .bin) from a zip
export const extract3DFilesFromZip = async (zip) => {
    const jszip = new JSZip();
    const contents = await jszip.loadAsync(zip);
    const result = [];

    for (const [filename, fileData] of Object.entries(contents.files)) {
        if (fileData.dir) continue;
        const baseName = filename.split('/').pop();
        const ext = baseName.substring(baseName.lastIndexOf(".")).toLowerCase();
        if (![".glb", ".gltf", ".bin"].includes(ext)) continue;

        const buf = await fileData.async("arraybuffer");
        const mimeType =
            ext === ".glb" ? "model/gltf-binary"
                : ext === ".gltf" ? "model/gltf+json"
                    : "application/octet-stream";
        result.push(new File([buf], baseName, { type: mimeType }));
    }
    return result;
};

export const scaleScene = (scene, targetSize) => {
    const targetSizeVal = targetSize ?? 2
    const box = new THREE.Box3().setFromObject(scene);
    const size = new THREE.Vector3();
    box.getSize(size);
    const scaleFactor = targetSizeVal / Math.max(size.x, size.y, size.z);
    scene.scale.set(scaleFactor, scaleFactor, scaleFactor);
    return scene;
};

/**
 * Fetches a zip from a URL, extracts 3D-model-related files (.glb/.gltf/.bin),
 * builds the correct in-memory blob URLs and returns a scaled THREE.Scene.
 *
 * The caller is responsible for managing loading state and storing the model.
 *
 * @param {string} url - HTTP(s) or blob URL pointing to a zip file
 * @param {object} options
 * @param {number} [options.targetSize] - Optional target size passed to scaleScene (defaults to 2)
 * @returns {Promise<{ scene: THREE.Object3D | null, mainFileName: string | null } | null>}
 */
export const extractAndLoadModelFromZipUrl = async (url, options = {}) => {
    const { targetSize } = options;
    // Tracks temporary object URLs created during zip extraction so they can be revoked.
    const tempObjectUrls = [];
    try {
        const zipResponse = await fetch(url);
        if (!zipResponse.ok) {
            throw new Error(`Failed to fetch zip: ${zipResponse.status}`);
        }

        const zipArrayBuffer = await zipResponse.arrayBuffer();
        const header = new Uint8Array(zipArrayBuffer.slice(0, 4));
        if (header[0] !== 80 || header[1] !== 75) {
            showToastMessage('error', 'Invalid zip file received');
            return null;
        }

        const zip = new JSZip();
        const contents = await zip.loadAsync(zipArrayBuffer);

        const bufferMap = {};
        let mainFileName = null;
        let mainExt = null;

        for (const [filename, fileData] of Object.entries(contents.files)) {
            if (fileData.dir) continue;
            const baseName = filename.split('/').pop();
            const ext = baseName.substring(baseName.lastIndexOf('.')).toLowerCase();
            if (!['.glb', '.gltf', '.bin'].includes(ext)) continue;
            bufferMap[baseName] = await fileData.async('arraybuffer');

            if (!mainFileName && (ext === '.glb' || ext === '.gltf')) {
                mainFileName = baseName;
                mainExt = ext;
            }
        }

        if (!mainFileName || !mainExt) {
            showToastMessage('error', 'No valid model file found inside the zip');
            return null;
        }

        const gltfLoader = createGltfLoader();
        let loadUrl;

        if (mainExt === '.gltf') {
            const fileMap = {};
            for (const [name, buf] of Object.entries(bufferMap)) {
                const ext = name.substring(name.lastIndexOf('.')).toLowerCase();
                const mimeType =
                    ext === '.gltf' ? 'model/gltf+json'
                        : ext === '.glb' ? 'model/gltf-binary'
                            : 'application/octet-stream';
                fileMap[name] = URL.createObjectURL(new Blob([buf], { type: mimeType }));
                tempObjectUrls.push(fileMap[name]);
            }

            const gltfText = new TextDecoder().decode(bufferMap[mainFileName]);
            const gltfJson = JSON.parse(gltfText);

            if (gltfJson.buffers) {
                gltfJson.buffers = gltfJson.buffers.map((buf) => {
                    const baseName = buf.uri && buf.uri.split('/').pop();
                    const resolved = (buf.uri && fileMap[buf.uri]) || (baseName && fileMap[baseName]);
                    return resolved ? { ...buf, uri: resolved } : buf;
                });
            }

            if (gltfJson.images) {
                gltfJson.images = gltfJson.images.map((img) => {
                    const baseName = img.uri && img.uri.split('/').pop();
                    const resolved = (img.uri && fileMap[img.uri]) || (baseName && fileMap[baseName]);
                    return resolved ? { ...img, uri: resolved } : img;
                });
            }

            const patchedBlob = new Blob([JSON.stringify(gltfJson)], { type: 'model/gltf+json' });
            loadUrl = URL.createObjectURL(patchedBlob);
            tempObjectUrls.push(loadUrl);
        } else {
            loadUrl = URL.createObjectURL(
                new Blob([bufferMap[mainFileName]], { type: 'model/gltf-binary' })
            );
            tempObjectUrls.push(loadUrl);
        }

        return await new Promise((resolve) => {
            gltfLoader.load(
                loadUrl,
                (gltf) => {
                    const scene = scaleScene(gltf.scene, targetSize);
                    resolve({ scene, mainFileName });
                },
                undefined,
                (error) => {
                    // Reuse the shared model-load failure helper to keep zip-path handling consistent.
                    notifyModelLoadFailure({ error, resolve });
                }
            );
        });
    } catch (err) {
        showToastMessage('error', `Failed to load zip model: ${err}`);
        return null;
    } finally {
        // Cleanup temporary blob URLs regardless of success/failure to avoid memory leaks.
        tempObjectUrls.forEach((objectUrl) => URL.revokeObjectURL(objectUrl));
    }
};


export const getElementCoordinates = (className) => {
    const element = document.querySelector(className);
    if (!element) {
        return {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: 0,
            height: 0
        };
    }
    const rect = element.getBoundingClientRect();
    return {
        top: rect.top || 0,
        left: rect.left || 0,
        right: rect.right || 0,
        bottom: rect.bottom || 0,
        width: rect.width || 0,
        height: rect.height || 0
    };
}

export function generate32ByteValue(type, length = 32) {
    // This code may be used in the future.
    // const numericChars = "0123456789";
    // Generate numeric string if type != key
    // if (type !== "key") {
    //     let result = "";
    //     for (let i = 0; i < length; i++) {
    //         const randomIndex = Math.floor(Math.random() * numericChars.length);
    //         result += numericChars[randomIndex];
    //     }
    //     return result;
    // }

    // Generate 32 random bytes → convert to hex (64 characters)
    const bytes = new Uint8Array(length);
    crypto.getRandomValues(bytes);

    return Array.from(bytes)
        .map(b => b.toString(16).padStart(2, "0"))
        .join("")
        .toUpperCase();
}


export const isValidUrl = (value) => {
    if (!value?.trim()) return false;

    const input = value.trim();

    // Allow host with port without protocol
    // Examples:
    // https://google.com
    // http://localhost:3000
    // 192.168.1.1:8080
    // 101:67:2:62:50000
    // goole:5000
    // google.com:5000
    // protocol://hostname.domain:5000/path

    const numericColonWithPortRegex = /^(https?:\/\/)?\d+:\d+:\d+:\d+:\d+$/;
    const ipv4WithPortRegex = /^(https?:\/\/)?(\d{1,3}\.){3}\d{1,3}:\d+$/;
    const hostnameWithPortRegex = /^(https?:\/\/)?[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*:\d+$/;
    const protocolHostnameWithPortPathRegex = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\/[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*:\d+(\/.*)?$/;

    if (numericColonWithPortRegex.test(input) || ipv4WithPortRegex.test(input) || hostnameWithPortRegex.test(input) || protocolHostnameWithPortPathRegex.test(input)) {
        return true;
    }

    try {
        const url = new URL(input);
        return ["http:", "https:"].includes(url.protocol) && !!url.hostname;
    } catch {
        return false;
    }
}
/**
 * @param {import('cesium').Viewer} viewer
 * @param {string} name
 * @returns {import('cesium').DataSource | undefined}
 */
const getDataSourceByName = (viewer, name) => {
    const sources = viewer.dataSources;
    for (let i = 0; i < sources.length; i++) {
        if (sources.get(i).name === name) return sources.get(i);
    }
    return undefined;
};

/**
 * @param {import('cesium').Viewer | null} viewer
 */
export const request_render = (viewer) => {
    if (!viewer) return
    viewer.scene.requestRender();
    setTimeout(() => {
        viewer.scene.requestRender();
    }, 100);
}

/** @type {string | null} */
let simHoveredGsId = null;
/** @type {Map<string, string>} */
const simGsBaseImageStore = new Map();

/**
 * Sets up a MOUSE_MOVE hover handler for ground station billboards in a CZML data source.
 * Swaps the GS billboard image to gs_hover.svg on hover and restores it on mouse-out.
 *
 * @param {import('cesium').Viewer | null} viewer
 * @param {string} [dataSourceName]
 * @returns {import('cesium').ScreenSpaceEventHandler | null}
 */
export const setup_gs_hover = (viewer, dataSourceName = 'GS_Object') => {
    if (!viewer) return null;

    const handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);

    handler.setInputAction((movement) => {
        const picked = viewer.scene.pick(movement.endPosition);
        const pickedEntity = picked?.id;
        /** @type {string | null} */
        const rawId = typeof pickedEntity?.id === 'string' ? pickedEntity.id : null;

        const gsDataSource = getDataSourceByName(viewer, dataSourceName);
        const pickedGs = rawId && gsDataSource?.entities?.getById(rawId) ? rawId : null;

        if (simHoveredGsId && simHoveredGsId !== pickedGs) {
            const prevEntity = gsDataSource?.entities?.getById(simHoveredGsId);
            if (prevEntity?.billboard) {
                prevEntity.billboard.image = simGsBaseImageStore.get(simHoveredGsId) ?? '/assets/un_select_gs.svg';
            }
            simHoveredGsId = null;
            request_render(viewer);
        }

        if (pickedGs && pickedGs !== simHoveredGsId) {
            const entity = gsDataSource.entities.getById(pickedGs);
            if (entity?.billboard) {
                const currentImage = entity.billboard.image?.getValue?.(Cesium.JulianDate.now())
                    ?? entity.billboard.image ?? '/assets/un_select_gs.svg';
                simGsBaseImageStore.set(pickedGs, currentImage);
                entity.billboard.image = '/assets/gs_hover.svg';
                simHoveredGsId = pickedGs;
                request_render(viewer);
            }
        }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

    return handler;
};

export const isValidBootTimeInput = (value) => {
    if (value === "") return true;

    // 1. Only allow numbers (digits and at most one decimal point) starting with a digit
    if (!/^\d+\.?\d*$/.test(value)) return false;

    const num = Number(value);

    // 2. Maximum limit is 120
    if (num > 120) return false;

    // 3. Switch check based on character length
    switch (value.length) {
        case 1:
            // Single digit must be between 1 and 9 so it can form 10-120
            return num >= 1 && num <= 9;
        default:
            // Double digit or longer: integer part must be at least 10
            return parseInt(value, 10) >= 10;
    }
};

export const isValidBootTimeFinalValue = (value) => {
    const num = Number(value);
    return value !== "" && !isNaN(num) && num >= 10 && num <= 120;
};

export const getBootTimeValidationMessage = (label) => {
    return getInvalidRangeErrorMessage(label, 10, 120, 's');
};

export const flattenedFeatureList = (tenantData) => {
    if (!tenantData?.features) {
        return tenantData;
    }

    const featureAllowed = {};

    Object.keys(tenantData.features).forEach(key => {
        const feature = tenantData.features[key];
        featureAllowed[key] = feature?.enabled ? 'Yes' : 'No';

        // Include limits if they exist (for features like missionModelling)
        if (feature?.limits) {
            Object.assign(featureAllowed, feature.limits);
        }

        // Include subfeatures if they exist
        if (feature?.subFeatures) {
            Object.keys(feature.subFeatures).forEach(subFeature => {
                featureAllowed[subFeature] = feature.subFeatures[subFeature]?.enabled ? 'Yes' : 'No';
            });
        }
    });

    // Include global limits
    if (tenantData?.globalLimits) {
        Object.assign(featureAllowed, tenantData.globalLimits);
    }

    return {
        ...tenantData,
        'feature-allowed': featureAllowed
    };
};


